/* eslint-disable no-param-reassign */
class FilterOptions {
  constructor(rootElement, events) {
    this.rootElement = rootElement;
    this.optionTypeAllSelector = '[data-entity="option-all"]';
    this.optionTypeDefaultSelector = '[data-entity="option"]';
    this.events = events;

    this.initState();
    this.attachEvents();
  }

  findElements() {
    this.optionTypeAll = this.rootElement.querySelector(this.optionTypeAllSelector);
    this.options = Array.from(this.rootElement.querySelectorAll(this.optionTypeDefaultSelector));
  }

  initState() {
    this.findElements();
    this.state = {
      activeOptionsCount: this.calcActiveOptionsCount(),
    };
  }

  attachEvents() {
    this.rootElement.addEventListener('click', this.optionTypeAllChangeHandler.bind(this));
    this.rootElement.addEventListener('change', this.optionChangeHandler.bind(this));
  }

  optionTypeAllChangeHandler(event) {
    if (!event.target.closest(this.optionTypeAllSelector)) return;

    this.findElements();

    this.state.activeOptionsCount = 0;

    this.renderOptionTypeAll();

    this.rootElement.dispatchEvent(this.events.changeEvent);
  }

  optionChangeHandler(event) {
    if (!event.target.closest(this.optionTypeDefaultSelector)) return;

    this.findElements();

    this.state.activeOptionsCount = this.calcActiveOptionsCount();

    this.renderOptionTypeAll();

    this.rootElement.dispatchEvent(this.events.changeEvent);
  }

  calcActiveOptionsCount() {
    let counter = 0;

    this.options.forEach((option) => {
      if (option.checked) {
        counter += 1;
      }
    });

    return counter;
  }

  renderOptionTypeAll() {
    const { activeOptionsCount } = this.state;

    if (activeOptionsCount === 0) {
      this.optionTypeAll.classList.add('filter__option_checked');

      this.options.forEach((option) => {
        option.checked = false;
      });
    }

    if (activeOptionsCount > 0) {
      this.optionTypeAll.classList.remove('filter__option_checked');
    }
  }

  getActiveOptionsCount() {
    return this.state.activeOptionsCount;
  }

  resetOptions() {
    this.state.activeOptionsCount = this.calcActiveOptionsCount();

    this.renderOptionTypeAll();

    this.rootElement.dispatchEvent(this.events.changeEvent);
  }
}

export default FilterOptions;
